import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'react-bootstrap/Button';
import UnifiedModal from '../UnifiedModal';

const ConfirmationModal = ({ show, onHide, onGoToProfile, data, dir }) => {
  const { t } = useTranslation();

  const footerButtons = [
    {
      variant: 'primary',
      onClick: onGoToProfile,
      children: t('booking.goToProfile')
    }
  ];

  return (
    <UnifiedModal
      show={show}
      onHide={onHide}
      title={t('booking.bookingReceived')}
      footerButtons={footerButtons}
      dir={dir}
    >
      <p>{t('booking.bookingSuccess', { reservationId: data?.bookingNumber, status: t(`booking.status.${data?.status}`) })}</p>
      <p>{t('booking.thankYou')}</p>
    </UnifiedModal>
  );
};

export default ConfirmationModal;